import { render, staticRenderFns } from "./PhoenixBoteManagement.vue?vue&type=template&id=04fff197&scoped=true"
import script from "./PhoenixBoteManagement.vue?vue&type=script&lang=js"
export * from "./PhoenixBoteManagement.vue?vue&type=script&lang=js"
import style0 from "./PhoenixBoteManagement.vue?vue&type=style&index=0&id=04fff197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fff197",
  null
  
)

export default component.exports